import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { promotionFetchById } from '../redux/actions'

class Promotiondetail extends Component {

    constructor(){
        super()
        this.state = {
            id: "",
            title: "",
            photo: "",
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        let params = this.getParams()
        this.props.promotionFetchById(params.id)
        this.setState({ 
            id: params.id,
            title: decodeURI(params.title),
            photo: params.photo+"&token="+params.token,
        })
    }

    getParams() {
        const str = this.props.location.search;
        let objURL = {};
        str.replace(
            new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
            ( $0, $1, $2, $3 ) => {
                objURL[ $1 ] = $3;
            }
        );
        return objURL;
    };

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-promotiondetail">
                <Analytics />
                <div className="promotiondetail-header">
                    <Backbtn />
                    <div className="title">
                        <p>โปรโมชั่น</p>
                    </div>
                    <Nav />
                </div>
                <div className="promotiondetail-banner container">
                    <Link to="">
                        <img src={this.state.photo} alt="โปรโมชั่นแอร์"/>
                    </Link>
                </div>
                <div className="promotiondetail-detail container">
                    <div className="each-detail">
                        <h2 className="promodetail-title">{this.state.title}</h2><br/>
                        {(this.props.promotion)?<p className="promodetail-content">{this.props.promotion.desc}</p>:<Loader />}
                    </div>

                    {/* <br />
                    <div>
                        <a href={"line://oaMessage/@apscooling/?"+this.state.title}>Send Line Message with id</a>
                        <br />
                        <a href={"line://oaMessage/@914rcxos/?STAR-AIRE: CE095/DE095"+" \nจำนวน: 2"}>Send Line Message with id</a>
                        <br />
                        <a href="line://msg/text/?testmessaging123">Send Line Message without id</a>
                    </div> */}

                </div>               
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ promotion }) => {
    return { 
        promotion: promotion.promotion
    }
}
 
export default connect(mapStateToProps, { promotionFetchById })(Promotiondetail)